<template>
  <div class="wlx-apply-table-wrapper">
    <div class="basic-head-main" :style="{backgroundImage:'url('+headBg+')'}">
      <div class="basic-head-con">
        <div class="head-title-con clearfix">
          <div class="fl basic-book-img-con">
            <img src="~assets/images/basic-book-img.png" alt />
          </div>
          <div class="fr head-title-word">
            <!-- <p class="p-title-1">“1+X”物流管理职业技能等级</p> -->
            <p class="p-title-1">{{tableTitle}}申请表</p>
            <p class="p-title-2 p-title-2-1">——北京中物联物流采购培训中心</p>
          </div>
        </div>
      </div>
    </div>
    <div class="apply-table-content">
      <!-- <p class="p-down-applyTable-btn" @click="downloadTable">下载申请表</p> -->
      <table border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td class="u-label-title">姓名</td>
          <td colspan="2">
            <el-input v-model="name"></el-input>
          </td>
          <td class="u-label-title">性别</td>
          <td colspan="2">
            <el-input v-model="sex"></el-input>
          </td>
          <td colspan="2" class="u-label-title">出生年月</td>
          <td colspan="2">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="bornDate"
              type="date"
              placeholder="请选择日期"
            ></el-date-picker>
          </td>
          <td colspan="3" rowspan="4" width="160px">
            <avatarUpload
              :url="urlAliyunOSS"
              :files.sync="avatar"
              :minWidth="200"
              :minHeight="256"
              :minSize="204800"
              format="image"
            ></avatarUpload>
          </td>
        </tr>
        <tr>
          <td class="u-label-title">民族</td>
          <td colspan="2">
            <el-input v-model="nation"></el-input>
          </td>
          <td class="u-label-title">政治面貌</td>
          <td colspan="2">
            <el-input v-model="polityOutlook"></el-input>
          </td>
          <td colspan="2" class="u-label-title">健康状况</td>
          <td colspan="2">
            <el-input v-model="healthy"></el-input>
          </td>
        </tr>
        <tr>
          <td rowspan="2" class="u-label-title">学历</td>
          <td rowspan="2" colspan="2">
            <el-input v-model="education" class="input-edu"></el-input>
          </td>
          <td class="u-label-title">从事职业</td>
          <td colspan="2">
            <el-input v-model="business"></el-input>
          </td>
          <td colspan="2" class="u-label-title">技术职称</td>
          <td colspan="2">
            <el-input v-model="jobPost"></el-input>
          </td>
        </tr>
        <tr>
          <td class="u-label-title">年限</td>
          <td colspan="2">
            <el-input v-model="jobYear"></el-input>
          </td>
          <td colspan="2" class="u-label-title">职业技能证书</td>
          <td colspan="2">
            <el-input v-model="skillCertify"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">工作单位</td>
          <td colspan="3">
            <el-input v-model="jobPlace"></el-input>
          </td>
          <td colspan="2" class="u-label-title">身份证号</td>
          <td colspan="5">
            <el-input v-model="IDNum"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">通信地址</td>
          <td colspan="10">
            <el-input v-model="linkAdderss"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">现居住地</td>
          <td colspan="10">
            <!-- <el-input v-model="linkAdderss"></el-input> -->
            <div class="td-select-city">
              <span>省份:</span>
              <el-select v-model="provincePid" clearable placeholder="省份" @change="provinceChange">
                <el-option
                  v-for="item in provinceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="td-select-city">
              <span>城市:</span>
              <el-select v-model="cityPid" clearable placeholder="城市" @change="cityChange">
                <el-option
                  v-for="item in cityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="td-select-city">
              <span>县/区:</span>
              <el-select v-model="areaPid" clearable placeholder="县/区">
                <el-option
                  v-for="item in areaList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">邮编</td>
          <td colspan="3">
            <el-input v-model="postCode"></el-input>
          </td>
          <td colspan="2" class="u-label-title">联系电话/手机号</td>
          <td colspan="5">
            <el-input v-model="phoneNum"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="u-label-title">专业擅长领域</td>
          <td colspan="10">
            <el-input type="textarea" :rows="8" v-model="majorField"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="label-job-con u-label-title">
              工作简历
              担任年度、职务
              <span>
                【 职称证明、
                专家证书丶
                职业技能证书丶
                大赛评委证书丶
                职称证书等】
              </span>
            </div>
          </td>
          <td colspan="10">
            <el-input type="textarea" :rows="8" v-model="jobResume"></el-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="label-job-con u-label-title">
              熟悉何种业务与
              技术、荣誉、业绩、成果和著作等。
            </div>
          </td>
          <td colspan="10">
            <el-input type="textarea" :rows="6" v-model="selfSpeciality"></el-input>
          </td>
        </tr>

        <tr>
          <td colspan="3" class="u-label-title">
            <div class="label-job-con">外语及其熟悉程度</div>
          </td>
          <td colspan="10">
            <el-input type="textarea" :rows="3" v-model="foreignLanguages"></el-input>
          </td>
        </tr>
        <!-- <tr>
          <td colspan="13">
            <div class="label-opinion-title u-label-title">推荐单位意见：</div>
            <div>
              <el-input type="textarea" :rows="8" v-model="unitOpinion" disabled></el-input>
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="13">
            <div class="label-opinion-title u-label-title">
              <span>北京中物联物流采购培训中心</span> 审核意见：
            </div>
            <div>
              <el-input type="textarea" :rows="8" v-model="evaluateOpinion" disabled></el-input>
            </div>
          </td>
        </tr>-->
      </table>
      <div class="submit-apply-btn">
        <el-button type="primary" @click="submitApply" :disabled="isSubmit">提交申请</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import avatarUpload from "components/avatarUpload.vue";

export default {
  data() {
    return {
      provinceList: [], //省
      cityList: [], //市
      areaList: [], //区
      tableTitle: "",
      isSubmit: false,
      jobContent: "",
      name: "",
      sex: "",
      bornDate: "",
      nation: "",
      polityOutlook: "",
      healthy: "",
      education: "",
      business: "",
      majorField: "",
      jobPost: "",
      jobYear: "",
      skillCertify: "",
      jobPlace: "",
      IDNum: "",
      linkAdderss: "",
      provincePid: "", //省
      cityPid: "",
      areaPid: "",
      postCode: "",
      phoneNum: "",
      jobResume: "",
      selfSpeciality: "",
      foreignLanguages: "",
      unitOpinion: "",
      evaluateOpinion: "",
      certifySituation: "",
      expertCertify: [
        {
          certifyNum: "",
          certifyDate: "",
          cerfityName: ""
        },
        {
          certifyNum: "",
          certifyDate: "",
          cerfityName: ""
        },
        {
          certifyNum: "",
          certifyDate: "",
          cerfityName: ""
        },
        {
          certifyNum: "",
          certifyDate: "",
          cerfityName: ""
        }
      ],
      urlAliyunOSS: "/api/design/osssign/getsign",
      avatar: "",
      headBg: require("assets/images/wlx-baic-bg-img.png"),
      trainApplyId: "",
      timer: ""
    };
  },
  props: {
    userType: {
      type: String,
      default: ""
    },
    certificateId:{
      type:String,
      default:""
    }
  },
  components: {
    avatarUpload
  },
  created() {
    if (this.userType == "1") {
      this.tableTitle = "讲师";
    }
    if (this.userType == "2") {
      this.tableTitle = "考评员";
    }
    this.getProvinceList();
  },
  methods: {
    submitApply() {
      const reg = /^1\d{10}$/;
      const reg1 = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (reg.test(this.phoneNum)) {
        if (this.provincePid == "") {
          this.$message.warning("请完善现居住地省份信息");
          return false;
        }
        if (this.cityPid == "") {
          this.$message.warning("请完善现居住地城市信息");
          return false;
        }
        if (this.areaPid == "") {
          this.$message.warning("请完善现居住地县/区信息");
          return false;
        }
        if (!reg1.test(this.IDNum)) {
          this.$message.warning("身份证号格式错误");
          return false;
        }
        this.$http
          .post("/api/XOrg/TrainApply/addTrainApply", {
            Type: Number(this.userType),
            Name: this.name,
            Sex: this.sex,
            Birth: this.bornDate,
            Nation: this.nation,
            PoliticalFace: this.polityOutlook,
            Health: this.healthy,
            Education: this.education,
            Occupation: this.business,
            TechnicalTitle: this.jobPost,
            Years: this.jobYear,
            Certificate: this.skillCertify,
            Photo: this.avatar,
            WorkUnit: this.jobPlace,
            CardNumber: this.IDNum,
            MailAddress: this.linkAdderss,
            provincePid: this.provincePid,
            cityPid: this.cityPid,
            areaPid: this.areaPid,
            ZipCode: this.postCode,
            Phone: this.phoneNum,
            Resume: this.jobResume,
            ExpertField: this.majorField,
            Achievements: this.selfSpeciality,
            ForeignLange: this.foreignLanguages,
            UnitOpinion: this.unitOpinion,
            AuditOpinion: this.evaluateOpinion,
            certificateId: this.certificateId
          })
          .then(res => {
            if (res.code > 0) {
              this.isSubmit = true;
              // this.$message({
              //   message: "申请成功",
              //   type: "success"
              // });
              this.$message({
                message: "报名成功,即将跳转到管理系统！",
                type: "success"
              });
              this.timer = setInterval(this.goclpp, 3000);
            } else {
              this.$message({
                message: res.msg,
                type: "warning"
              });
            }
          });
      } else {
        this.$message({
          message: "请输入正确的手机号",
          type: "error"
        });
      }
    },
    downloadTable() {
      this.$http.post("/api/XOrg/TrainApply/eportTrainApply", {
        TrainApplyId: this.trainApplyId
      });
    },
    goclpp() {
      this.$router.push({
        name: "TrainApplyManager"
      });
    },
    getProvinceList() {
      this.$http.post("/api/XOrg/District/getProvinceList").then(res => {
        if (res.code > 0) {
          this.provinceList = res.province;
        } else {
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    getCityList() {
      this.$http
        .post("/api/XOrg/District/getCityList", {
          province: this.provincePid
        })
        .then(res => {
          if (res.code > 0) {
            this.cityList = res.cityList;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
    },
    getCountyList() {
      this.$http
        .post("/api/XOrg/District/getCountyList", {
          city: this.cityPid
        })
        .then(res => {
          if (res.code > 0) {
            this.areaList = res.countylist;
          } else {
            this.$message({
              message: res.msg,
              type: "warning"
            });
          }
        });
    },
    provinceChange() {
      this.cityPid = "";
      this.areaPid = "";
      this.getCityList();
    },
    cityChange() {
      this.areaPid = "";
      this.getCountyList();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<style lang="scss">
.wlx-apply-table-wrapper {
  height: 100%;
  overflow: auto;
  background: #f0f6ff;
  .basic-head-main {
    height: 706px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    .basic-head-con {
      margin: 0 auto;
      width: 1000px;
    }
    .head-logo-con {
      padding: 26px 0 0 26px;
    }
    .logo-img-val {
      height: 40px;
    }
    .head-title-con {
      position: relative;
      padding-top: 40px;
    }
    .basic-book-img-con {
      margin-left: 10px;
    }
    .head-title-word {
      position: absolute;
      right: 0;
      top: 80px;
      z-index: 100;
      color: #fff;
    }
    .p-title-1 {
      font-size: 55px;
      font-weight: bold;
      text-align: center;
    }
    .p-title-2-1 {
      margin-top: 50px;
      text-align: right;
      font-size: 20px;
    }
  }
  .apply-table-content {
    margin: -325px auto 0;
    padding: 20px 0;
    padding-top: 50px;
    width: 1000px;
    background: #fff;
  }
  .p-down-applyTable-btn {
    text-align: right;
    color: #0365f5;
    padding: 0 22px 20px 0;
    cursor: pointer;
    font-size: 17px;
  }
  .apply-table-title {
    padding: 20px 0;
    text-align: center;
  }
  .submit-apply-btn {
    padding: 20px 0;
    text-align: center;
  }
  .label-job-con {
    padding: 0 20px;
  }
  table {
    margin: 0 auto;
    width: 960px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    table-layout: fixed;
    word-break: break-all;
    background: #f0f0f0;
  }
  .u-label-title {
    font-weight: bold;
  }
  .demo-table {
    margin-top: 100px;
  }
  .expert-certify-ul {
    height: 100%;
  }
  .expert-certify-li {
    width: 25%;
  }
  .certify-li-cell {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
  }
  .certify-li-cell-num {
    border-top: none;
  }
  .fistCertify {
    .certify-li-cell {
      border-left: none;
    }
  }
  .el-textarea__inner,
  .el-input__inner {
    border: none;
    font-size: 16px;
    color: #000;
  }
  .input-edu .el-input__inner {
    height: 82px;
    line-height: 82px;
  }
  .el-textarea__inner:focus {
    border: none;
  }
  .el-input__inner:focus {
    border: none;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  table td {
    border-left: 1px solid #999;
    border-top: 1px solid #999;
    text-align: center;
  }
  .label-opinion-title {
    padding: 10px;
    text-align: left;
  }
  .sp-mark-label {
    color: red;
  }
  .h4-major-title {
    padding: 10px 0;
  }
  td {
    height: 40px;
    // width: 76.9px;
    font-size: 16px;
  }
  .td-select-city {
    width: 33.333%;
    display: inline-block;
    .el-select {
      width: 75%;
    }
  }
}
</style>
